<template lang="pug">
  el-carousel(
    :loop="customConfig.loop"
    :height="customConfig.height"
    :autoplay="customConfig.autoplay"
    :trigger="customConfig.trigger"
    :arrow="customConfig.arrow"
    :indicator-position="customConfig.indicatorPosition"
    @change="changePdf"
    ref="carousel"
  )
    el-carousel-item(
      v-for='documento in documentosBytes',
      :key='documento.id'
      v-if="documento.bytes"
    )
      app-pdf-viewer(
        :key='`pdf-${documento.id}`'
        :bytes="documento.bytes"
        v-if="documento.bytes && documento.id === documentoAtual.id"
      )

</template>

<script>
import AppPdfViewer from '@/components/AppPDFViewer'
export default {
  components: { AppPdfViewer },

  props: {
    documentosBytes: {
      default: () => [{ id: null, bytes: null }],
      type: Array
    },
    primeiroDocumento: { type: Object },

    customConfig: {
      default: () => ({
        loop: false,
        height: '550px',
        autoplay: false,
        trigger: 'click',
        arrow: 'always',
        indicatorPosition: 'none'
      }),
      type: Object
    }
  },

  data () {
    return {
      documentoAtual: {}
    }
  },

  created () {
    this.changePdf(0)
  },

  mounted () {
    this.$nextTick(function () {
      if (this.primeiroDocumento) {
        this.setPdf(
          this.documentosBytes
            .map(doc => doc.id)
            .indexOf(this.primeiroDocumento.id)
        )
      }
    })
  },

  methods: {
    changePdf (index) {
      this.documentoAtual = this.documentosBytes[index]
      this.$emit('changePdfDownload', this.documentoAtual)
    },

    setPdf (index) {
      this.changePdf(index)
      this.$refs.carousel.setActiveItem(index)
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .el-carousel__arrow {
  width: 60px !important;
  height: 60px !important;
  font-size: 34px !important;
  color: #009f61;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPDFSlider.vue